module.exports = "<ul class=\"list-group\">\r\n  <li class=\"list-group-item\"\r\n      *ngFor=\"let bc of barcodes\">\r\n    {{bc.ean}} ({{bc.ean_type}})\r\n  </li>\r\n</ul>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/identity/barcode/barcode-list/barcode-list.component.html
// module id = ./src/app/identity/barcode/barcode-list/barcode-list.component.html
// module chunks = main